query ApprovalHistoryItem($id: UUID!) {
  approvalHistoryItem(id: $id) {
    id
    id1
    purchaseOrderItem {
      id
      purchaseOrder {
        _isUpdatable
        id
        _rowTimestamp
        _subjectToTax
        _subjectToDiscount
        purchaseOrderNumber
        purchaseOrderTypeId
        _isDistributionUpdateAllowed
        businessUnit {
          _isProductionBusinessUnit
          id
          name
          companyAddress {
            addressAlias
            addressLine1
            addressLine2
            cityName
            postalCode
          }
        }
        currency {
          id
          isoCode
          currencySymbol
        }
        purchaseOrderItems {
          nodes {
            __typename
            _rowTimestamp
            id
            _rowTimestamp
            purchaseOrderItemTypeId
            purchaseOrderItemType {
              calculationType
              layoutType
              abbreviation
              description
              id
            }
            itemNumber
            _isUpdatable
            _isDeletable
            itemExtendedAmount
            displayPoItemAccount
            displayPoItemQuantity
            displayPoItemUnitPrice
            displayPoItemTotal
            displayPoItemDescription
            displayPoItemRentalTerm
            displayPoItemType
            description
            isTaxable
            isDiscounted
            _extendedItemTotal
            itemQuantity
            itemRentalDates
            itemUnitPrice
            itemFromDate
            _isActive
          }
        }
      }
      purchaseOrderItemDistributions {
        nodes {
          id
        }
      }
    }
  }
}
